import DsModal from '@/common/DsModal';
import { isFallbackImage } from '~/utilities/isFallbackImage';

type OwnProps = {
  description: string;
  imageUrl: string;
  isOpen: boolean;
  name: string;
  onClose: () => void;
};

export default function PackageDetailsModal({
  description,
  imageUrl,
  isOpen,
  name,
  onClose
}: OwnProps) {
  const formattedDescription = description
    .split('\n')
    .filter(Boolean)
    .join(', ');
  const isFallback = isFallbackImage(imageUrl);
  const renderImage = imageUrl && !isFallback;

  return (
    <DsModal
      closeIcon
      desktopWidth="552px"
      isOpen={isOpen}
      mobileStyle="inset"
      onClose={onClose}
    >
      <div className="flex flex-col gap-2xl">
        {renderImage && (
          <img alt={name} className="w-full rounded-md " src={imageUrl} />
        )}
        <div className="flex flex-col gap-lg">
          <h3 className="t-heading-lg text-text-strong">{name}</h3>
          <p className="t-body-sm text-text-default">{formattedDescription}</p>
        </div>
      </div>
    </DsModal>
  );
}
